<template>
		<div>
				<div class="page-content header-clear pb-0">
						<div class="card bg-transparent" data-card-height="cover">
								<div class="card-center text-center">
										<i class="fa fa-exclamation-triangle fa-8x color-red2-dark"></i>
										<h1 class="fa-6x mt-5 font-900">404</h1>
										<h4 class="mb-5 mt-3">Page not Found</h4>
										<p>
												The page you're looking for cannot be found.<br>
												How about trying again?
										</p>
										<div class="row ml-5 mr-5 mt-5 mb-0">
												<div class="col-6">
														<router-link to="/home" class="btn btn-m rounded-sm btn-full bg-red2-dark text-uppercase font-900">Home</router-link>
												</div>
										</div>
								</div>
						</div>
				</div>
		</div>

</template>

<script>
    export default {
        name: "NotFound"
    }
</script>

<style scoped>

</style>